import Highcharts from 'highcharts';
import { chartColors } from '@/common/chart/chart-colors.js';

export const psHighchartsConfig: Highcharts.Options = {
    title: {
        text: 'Line chart title here',
        style: {
            color: 'var(--palette-gray-100)',
        },
    },
    credits: {
        enabled: false,
    },
    subtitle: {
        text: 'Subtitle here (optional)',
        style: {
            color: 'var(--palette-gray-70)',
        },
    },
    xAxis: {
        type: 'datetime',
        title: {
            text: 'X axis label (optional)',
            style: {
                color: 'var(--palette-gray-100)',
            },
        },
        tickPixelInterval: 200,
        tickLength: 0,
        startOfWeek: 0,
        dateTimeLabelFormats: {
            day: '%b %e',
            week: '%b %e',
            month: '%b %Y',
        },
        gridLineColor: 'var(--palette-gray-40)',
        labels: {
            style: {
                color: 'var(--palette-gray-100)',
                opacity: 0.8,
            },
        },
    },
    chart: {
        type: 'line',
        height: 600,
        backgroundColor: 'var(--palette-gray-0)',
        style: {
            fontFamily: 'Inter',
        },
        spacingTop: 20,
        spacingLeft: 0,
    },
    colors: chartColors,
    yAxis: {
        title: {
            text: 'Event count',
            style: {
                color: 'var(--palette-gray-100)',
            },
            align: 'middle',
        },
        min: 0,
        gridLineColor: 'var(--palette-gray-40)',
        labels: {
            align: 'right',
            style: {
                color: 'var(--palette-gray-100)',
                opacity: 0.8,
            },
        },
        tickPixelInterval: 92,
        allowDecimals: false,
        softMax: 1,
        max: undefined,
    },
    plotOptions: {
        line: {
            dataLabels: {
                enabled: false,
            },
            enableMouseTracking: true,
            stickyTracking: true,
            accessibility: {
                keyboardNavigation: {
                    enabled: true,
                },
            },
            marker: {
                enabled: true,
            },
            showInLegend: true,
        },
    },
    series: [],
    legend: {
        enabled: true,
        className: 'chart-legend',
        itemStyle: {
            color: 'var(--palette-gray-100)',
        },
        itemHoverStyle: {
            color: 'var(--palette-gray-60)',
        },
    },
    tooltip: {
        className: 'chart-tooltip',
        shadow: {
            color: 'rgba(var(--raw-palette-gray-100), 0.07)',
            width: 12,
        },
        backgroundColor: 'var(--palette-gray-0)',
        style: {
            color: 'var(--palette-gray-90)',
        },
    },
};

export const top10FeaturesByVisitorsConfig: Highcharts.Options = {
    ...psHighchartsConfig,
    title: {
        text: 'Top 10 Features by Visitors',
        style: {
            color: 'var(--palette-gray-100)',
        },
    },
    chart: {
        type: 'bar',
        displayErrors: false,
        backgroundColor: 'var(--palette-gray-0)',
        style: {
            fontFamily: 'Inter',
        },
    },
    xAxis: {
        type: 'category',
        labels: {
            style: {
                color: 'var(--palette-gray-100)',
                opacity: 0.8,
            },
        },
        gridLineColor: 'var(--palette-gray-40)',
    },
    yAxis: {
        title: {
            text: 'Number of Visitors',
            style: {
                color: 'var(--palette-gray-100)',
            },
        },
        labels: {
            style: {
                color: 'var(--palette-gray-100)',
                opacity: 0.8,
            },
        },
        gridLineColor: 'var(--palette-gray-40)',
    },
    plotOptions: {},
    legend: {
        enabled: true,
        className: 'chart-legend',
        itemStyle: {
            color: 'var(--palette-gray-100)',
        },
        itemHoverStyle: {
            color: 'var(--palette-gray-60)',
        },
    },
    tooltip: {
        className: 'chart-tooltip',
        shadow: {
            color: 'rgba(var(--raw-palette-gray-100), 0.07)',
            width: 12,
        },
        backgroundColor: 'var(--palette-gray-0)',
        style: {
            color: 'var(--palette-gray-90)',
        },
    },
};

export const top10PagesByVisitorsConfig: Highcharts.Options = {
    ...psHighchartsConfig,
    title: {
        text: 'Top 10 Pages by Visitors',
        style: {
            color: 'var(--palette-gray-100)',
        },
    },
    chart: {
        type: 'bar',
        displayErrors: false,
        backgroundColor: 'var(--palette-gray-0)',
        style: {
            fontFamily: 'Inter',
        },
    },
    xAxis: {
        type: 'category',
        labels: {
            style: {
                color: 'var(--palette-gray-100)',
                opacity: 0.8,
            },
        },
        gridLineColor: 'var(--palette-gray-40)',
    },
    yAxis: {
        title: {
            text: 'Number of Visitors',
            style: {
                color: 'var(--palette-gray-100)',
            },
        },
        labels: {
            style: {
                color: 'var(--palette-gray-100)',
                opacity: 0.8,
            },
        },
        gridLineColor: 'var(--palette-gray-40)',
    },
    plotOptions: {},
    legend: {
        enabled: true,
        className: 'chart-legend',
        itemStyle: {
            color: 'var(--palette-gray-100)',
        },
        itemHoverStyle: {
            color: 'var(--palette-gray-60)',
        },
    },
    tooltip: {
        className: 'chart-tooltip',
        shadow: {
            color: 'rgba(var(--raw-palette-gray-100), 0.07)',
            width: 12,
        },
        backgroundColor: 'var(--palette-gray-0)',
        style: {
            color: 'var(--palette-gray-90)',
        },
    },
};

export const top10FeaturesByEventsConfig: Highcharts.Options = {
    ...psHighchartsConfig,
    title: {
        text: 'Top 10 Features by Events',
        style: {
            color: 'var(--palette-gray-100)',
        },
    },
    chart: {
        type: 'bar',
        displayErrors: false,
        backgroundColor: 'var(--palette-gray-0)',
        style: {
            fontFamily: 'Inter',
        },
    },
    xAxis: {
        type: 'category',
        labels: {
            style: {
                color: 'var(--palette-gray-100)',
                opacity: 0.8,
            },
        },
        gridLineColor: 'var(--palette-gray-40)',
    },
    yAxis: {
        title: {
            text: 'Number of Events',
            style: {
                color: 'var(--palette-gray-100)',
            },
        },
        labels: {
            style: {
                color: 'var(--palette-gray-100)',
                opacity: 0.8,
            },
        },
        gridLineColor: 'var(--palette-gray-40)',
    },
    legend: {
        enabled: true,
        className: 'chart-legend',
        itemStyle: {
            color: 'var(--palette-gray-100)',
        },
        itemHoverStyle: {
            color: 'var(--palette-gray-60)',
        },
    },
    tooltip: {
        className: 'chart-tooltip',
        shadow: {
            color: 'rgba(var(--raw-palette-gray-100), 0.07)',
            width: 12,
        },
        backgroundColor: 'var(--palette-gray-0)',
        style: {
            color: 'var(--palette-gray-90)',
        },
    },
};

export const top10PagesByEventsConfig: Highcharts.Options = {
    ...psHighchartsConfig,
    title: {
        text: 'Top 10 Pages by Events',
        style: {
            color: 'var(--palette-gray-100)',
        },
    },
    chart: {
        type: 'bar',
        displayErrors: false,
        backgroundColor: 'var(--palette-gray-0)',
        style: {
            fontFamily: 'Inter',
        },
    },
    xAxis: {
        type: 'category',
        labels: {
            style: {
                color: 'var(--palette-gray-100)',
                opacity: 0.8,
            },
        },
        gridLineColor: 'var(--palette-gray-40)',
    },
    yAxis: {
        title: {
            text: 'Number of Events',
            style: {
                color: 'var(--palette-gray-100)',
            },
        },
        labels: {
            style: {
                color: 'var(--palette-gray-100)',
                opacity: 0.8,
            },
        },
        gridLineColor: 'var(--palette-gray-40)',
    },
    plotOptions: {},
    legend: {
        enabled: true,
        className: 'chart-legend',
        itemStyle: {
            color: 'var(--palette-gray-100)',
        },
        itemHoverStyle: {
            color: 'var(--palette-gray-60)',
        },
    },
    tooltip: {
        className: 'chart-tooltip',
        shadow: {
            color: 'rgba(var(--raw-palette-gray-100), 0.07)',
            width: 12,
        },
        backgroundColor: 'var(--palette-gray-0)',
        style: {
            color: 'var(--palette-gray-90)',
        },
    },
};

export const avgDailyTimeOnAppConfig: Highcharts.Options = {
    ...psHighchartsConfig,
    title: {
        text: 'Average Daily Time on App',
        style: {
            color: 'var(--palette-gray-100)',
        },
    },
    xAxis: {
        title: {
            text: 'Day',
            style: {
                color: 'var(--palette-gray-100)',
            },
        },
        type: 'datetime',
        labels: {
            style: {
                color: 'var(--palette-gray-100)',
                opacity: 0.8,
            },
        },
        gridLineColor: 'var(--palette-gray-40)',
    },
    yAxis: {
        title: {
            text: 'Time in minutes',
            style: {
                color: 'var(--palette-gray-100)',
            },
        },
        labels: {
            style: {
                color: 'var(--palette-gray-100)',
                opacity: 0.8,
            },
        },
        gridLineColor: 'var(--palette-gray-40)',
    },
    legend: {
        enabled: true,
        className: 'chart-legend',
        itemStyle: {
            color: 'var(--palette-gray-100)',
        },
        itemHoverStyle: {
            color: 'var(--palette-gray-60)',
        },
    },
    tooltip: {
        className: 'chart-tooltip',
        shadow: {
            color: 'rgba(var(--raw-palette-gray-100), 0.07)',
            width: 12,
        },
        backgroundColor: 'var(--palette-gray-0)',
        style: {
            color: 'var(--palette-gray-90)',
        },
    },
};

export const avgWeeklyTimeOnAppConfig: Highcharts.Options = {
    ...psHighchartsConfig,
    title: {
        text: 'Average Weekly Time on App',
        style: {
            color: 'var(--palette-gray-100)',
        },
    },
    xAxis: {
        title: {
            text: 'First day of week',
            style: {
                color: 'var(--palette-gray-100)',
            },
        },
        type: 'datetime',
        labels: {
            style: {
                color: 'var(--palette-gray-100)',
                opacity: 0.8,
            },
        },
        gridLineColor: 'var(--palette-gray-40)',
    },
    yAxis: {
        title: {
            text: 'Time in minutes',
            style: {
                color: 'var(--palette-gray-100)',
            },
        },
        labels: {
            style: {
                color: 'var(--palette-gray-100)',
                opacity: 0.8,
            },
        },
        gridLineColor: 'var(--palette-gray-40)',
    },
    legend: {
        enabled: true,
        className: 'chart-legend',
        itemStyle: {
            color: 'var(--palette-gray-100)',
        },
        itemHoverStyle: {
            color: 'var(--palette-gray-60)',
        },
    },
    tooltip: {
        className: 'chart-tooltip',
        shadow: {
            color: 'rgba(var(--raw-palette-gray-100), 0.07)',
            width: 12,
        },
        backgroundColor: 'var(--palette-gray-0)',
        style: {
            color: 'var(--palette-gray-90)',
        },
    },
};
